module.exports = __webpack_public_path__ + "static/media/robotCarLineTracker.781f132b.mp4";